import { useEffect, useState } from 'react'
// redux
import { useSelector } from 'react-redux'
// third party
import tawkTo from '../third-party/tawk_api'

// https://developer.tawk.to/javascript-api/?lang=es
export default function useChat() {
	// redux
	const {
		session: { email, fullName }
	} = useSelector(state => state)
	tawkTo({
		fullName,
		email
	})
	const [Tawk, setTawk] = useState(window.Tawk_API || false)
	const [allowedChat, setAllowedChat] = useState(false)
	const [isChatObject, setIsChatObject] = useState(null)

	const initChat = async ({ kindServices = '', tags, dataAdditional } = {}) => {
		if (!Tawk) return
		let flattedTag

		if (tags) {
			for (let i = 0; i < tags.length; i++) {
				flattedTag = `${flattedTag || ''}${tags[i]}, `
			}
		}

		let payloadAttr = {
			correo: email,
			fullName,
			tipoDeServicio: kindServices
		}
		if (flattedTag) {
			payloadAttr = { ...payloadAttr, listServices: flattedTag }
		}
		if (dataAdditional && typeof dataAdditional === 'object') {
			payloadAttr = { ...payloadAttr, ...dataAdditional }
		}
		if (Tawk.setAttributes) {
			Tawk.setAttributes(payloadAttr, function (error) {
				throw new Error(error)
			})
		}
		if (tags) {
			Tawk.addTags(tags, function (error) {
				throw new Error(error)
			})
		}

		Tawk.hasOwnProperty('maximize') && Tawk.maximize()
		if (isChatObject) {
			isChatObject.style = 'display: block !important;'
		}
	}

	// valid if chat was minimized
	const validObject = () =>
		setTimeout(() => {
			if (isChatObject === null) {
				const object = document.querySelector('body > div:last-child') | null
				object !== null ? setIsChatObject(object) : validObject()
			} else {
				validObject()
			}
		}, 500)

	const isClose = isChatObject && (Tawk.isChatMinimized() || false)

	if (isClose) isChatObject.style = 'display: none !important;'

	// validate complete charge
	const validateCharge = () =>
		setTimeout(() => {
			completeCharge()
		}, 500)

	const completeCharge = () => {
		if (allowedChat || !Tawk) return

		if (
			!Object.keys(Tawk).length > 0 ||
			!Tawk.hasOwnProperty('maximize') ||
			!Tawk.hasOwnProperty('setAttributes')
		) {
			return validateCharge()
		}

		setAllowedChat(true)
	}

	useEffect(() => {
		if (!window.Tawk_API) return

		setTawk(window.Tawk_API)
		!allowedChat && completeCharge()

		if (email && fullName) {
			window.Tawk_API.visitor = {
				name: fullName,
				email
			}
		}
	}, [window.Tawk_API, Tawk])

	useEffect(() => {
		validObject()
		return () => clearTimeout(validObject, validateCharge)
	}, [])

	return {
		Tawk,
		initChat,
		allowedChat
	}
}

// https://saludcontinua.comfama.com/instalacion?utm_source=sendgrid.com&utm_medium=email&utm_campaign=website
